import { useCallback } from 'react';
import useToggle from './useToggle';

/**
 * 默认切换布尔值状态，也可以接收一个参数作为新的值
 */
var useBoolean = function useBoolean() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var _useToggle = useToggle(defaultValue),
      state = _useToggle.state,
      toggle = _useToggle.toggle;

  var setTrue = useCallback(function () {
    return toggle(true);
  }, [toggle]);
  var setFalse = useCallback(function () {
    return toggle(false);
  }, [toggle]);
  var handler;
  handler = [state, toggle, setTrue, setFalse];
  handler.state = state;
  handler.toggle = toggle;
  handler.setTrue = setTrue;
  handler.setFalse = setFalse;
  return handler;
};

export default useBoolean;